<template>
    <div class="lm-order-fields">
        <div class="lm-order-fields__title">
            Адрес доставки
        </div>

        <combo-input
            class="form-market__group"
            :value="delivery['country']"
            @input="inputCountry"
            @blur="$v.delivery.country.$touch()"
            label="Страна"
            :error-visible="$v.delivery.country.$error"
            :options="countryOptions"
            option-label="label"
            option-value="value" />

        <combo-input
            class="lm-order-fields__group"
            v-for="item in deliveryList"
            :key="item.name"
            v-model="delivery[item.name]"
            @blur="$v.delivery[item.name].$touch()"
            :label="item.label"
            :error-visible="$v.delivery[item.name].$error"
            :options="getContact(item.name)" />
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import {mapGetters} from 'vuex';
import ComboInput from '../../common/ComboInput.vue';

export default {
    name: 'OrderDeliveryFields',
    components: {ComboInput},
    props: {
        initialDelivery: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            delivery: {
                country: '',
                region: '',
                city: '',
                address: '',
            },
            deliveryList: [
                {
                    name: 'region',
                    label: 'Регион',
                },
                {
                    name: 'city',
                    label: 'Населенный пункт',
                },
                {
                    name: 'address',
                    label: 'Адрес',
                },
            ],
        };
    },
    validations: {
        delivery: {
            country: { required },
            region: { required },
            city: { required },
            address: { required },
        },
    },
    computed: {
        ...mapGetters('market', [
            'filteredContacts',
        ]),
        countryOptions() {
            if (this.filteredContacts && this.filteredContacts.deliveryData) {
                const data = this.filteredContacts.deliveryData;
                const res = data.map(item => {
                    const country = item.country; const region = item.region; const city = item.city; const
                        address = item.address;
                    return {
                        value: {
                            country,
                            region,
                            city,
                            address,
                        },
                        label: `${country}, ${region}, ${city}, ${address}`,
                    };
                });
                return res;
            }
            return [];
        },
    },
    watch: {
        delivery: {
            handler(newDelivery) {
                this.$emit('update:delivery', { ...newDelivery });
            },
            deep: true,
        },
    },
    created() {
        if (this.initialDelivery) {
            this.delivery = { ...this.initialDelivery };
        }
    },
    methods: {
        getContact(field) {
            if (this.filteredContacts && this.filteredContacts.deliveryData) {
                return this.filteredContacts.deliveryData.map(item => item[field]);
            }
        },
        inputCountry(val) {
            if (typeof val === 'object') {
                this.delivery = { ...val };
            } else {
                this.delivery.country = val;
            }
        },
    },
};
</script>
